// extracted by css-extract-rspack-plugin
var _1 = "style-module__beforegiant--QgDLK";
var _2 = "style-module__container--IcqJc";
var _3 = "style-module__enormous--h1uzs";
var _4 = "style-module__giant--wxqMW";
var _5 = "style-module__imageBackgroundValid--hk2MY";
var _6 = "style-module__imageHintContainer--nbijg";
var _7 = "style-module__imageHintIcon--YEHdz";
var _8 = "style-module__imageHintPopup--NFbQO";
var _9 = "style-module__large--leVzY";
var _a = "style-module__middle--AftIv";
var _b = "style-module__pointer--QHONr";
var _c = "style-module__small--PQSFA";
export { _1 as "beforegiant", _2 as "container", _3 as "enormous", _4 as "giant", _5 as "imageBackgroundValid", _6 as "imageHintContainer", _7 as "imageHintIcon", _8 as "imageHintPopup", _9 as "large", _a as "middle", _b as "pointer", _c as "small" }
